import { config } from '@/config';
import { getStoreNameFromStoreUrl } from '@/helpers';

export const link = {
  isOpenAppEmbedUrl: `https://admin.shopify.com/store/${getStoreNameFromStoreUrl(
    config.shop,
  )}/themes/current/editor?context=apps&activateAppId=${process.env.REACT_APP_EMBED_APP_ID}/omg-app-age`,
  codeEditor: `https://admin.shopify.com/store/${getStoreNameFromStoreUrl(config.shop)}/themes/current/`,
};

export const linkGoogleFonts =
  'https://fonts.googleapis.com/css2?family=Fira+Sans:wght@400;500;600;700&family=Poppins:wght@400;500;600;700&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap';
